//@ts-nocheck
import React from "react";
import SurveySteperController, { Props } from "./SurveySteperController.web";
import {
  withStyles,
  Grid,
  createStyles,
  ThemeProvider,
} from "@material-ui/core";
import { Prompt, withRouter } from "react-router-dom";

import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialogBox from "../../../../components/src/withDialog.web";
import AboutUsSurveyStep from "./AboutUsSurveyStep.web";
import CashFlow from "./CashFlow.web";
import TaxSaving from "./TaxSaving.web";
import BusinessNeed from "./BusinessNeed.web";
import Saving from "./Saving.web";
import Reporting from "./Reporting.web";
import Summary from "./Summary.web";
import PaymentPage, { Thankyou } from "../CPAPayment.web.tsx";
import MeetingSchrdulePage from "./Schedule.web.tsx";
import PriceHiddenThankYou from "./PriceHiddenThankYou.web";
import PotentialSavings from "../PotentialSavings.web";
import { themeProps } from "../../../../web/src/theme2";
import { createTheme } from "@material-ui/core/styles";
import TernaryCheck from "../TernaryCheck.web";
import MagicLinkHeader from "./layout/MagicLinkHeader.web";
import StepHeader from "./layout/StepHeader.web";
import { StepProgressContext } from "./layout/StepProgressContext";
import { getStepProgress, getAboutYouStepCount } from "./layout/stepProgress";
import { getFirmContactHref } from "./layout/firmContact";
import { getStepSection } from "./layout/stepSections";
import { MAGIC_LINK_PRIMARY, magicLinkColors, magicLinkLayout } from "./layout/magicLinkTokens";
import { CURRENT_SITUATION, getFirmName, getOptionOrderNo } from "./surveyOptions";

const steps = [
  "About You",
  "Cash Flow",
  "Tax Savings",
  "Business Needs",
  "Savings",
  "Reporting",
  "Summary",
];
let checkSteps = 0;
const drawerWidth = 240;
const careerNeedRetirmentDescription =
  "I’m retired or I don’t need help with improving my future career earnings.";
const taxSavingMaximizingDescription =
  "Maximizing my tax savings isn’t important to me at this time.";
const cashflowDontNeedHelpDescription =
  "I’m okay with my current income & spending and don’t need any help with cash flow.";
export class SurveySteper extends SurveySteperController {
  constructor(props: Props) {
    super(props);
  }
  rootRef = React.createRef(null);
  unloadCallback = (event) => {
    event.preventDefault();
    event.returnValue = "";
    return "";
  };
  componentWillUnmount(): Promise<void> {
    window.removeEventListener("beforeunload", this.unloadCallback);
    window.clearTimeout(this.generatingTimer);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isPriceHiddenThankYou && this.state.isPriceHiddenThankYou) {
      window.removeEventListener("beforeunload", this.unloadCallback);
    }
  }
  async componentDidMount() {
    window.addEventListener("beforeunload", this.unloadCallback);
    const data = this?.props?.history?.location?.state?.state;
    this.setState(
      {
        email: data?.clientDetail?.email,
        firstName: data?.clientDetail?.first_name,
        lastName: data?.clientDetail?.last_name,
        phoneNumber: data?.clientDetail?.phone_number,
        paymentAccessToken: data?.access_token,
        isPaymentEnable: data?.access_token ? true : false,
        cpaData: data?.cpaDetail,
        aboutUsEnable: data?.clientDetail?.email ? true : false,
        accountId: data?.accountId,
        cpaSurveySetting: data?.cpaSurveySetting || {},
        surveyLogId: data?.surveyLogId,
        type: data?.type,
        isEcheckPaymentAvailable: data?.isEcheckPaymentAvailable,
        theme: data?.cpaDetail?.theme,
      },
      () => {
        this.getFirmQuestions(data?.accountId);
        const cfs_survey_setting =
          this.state.cpaData?.survey_setting?.data?.attributes || {};
        const package_self_enrollment = (
          cfs_survey_setting.self_enrollment_package_ids || []
        ).map(Number);
        this.setTheme(data?.cpaDetail?.theme);
        this.setState({
          package_self_enrollment: package_self_enrollment,
          self_enrollment: cfs_survey_setting?.self_enrollment,
        });
      }
    );
  }

  handleBack = () => {
    this.setState(
      {
        activeStep: this.state.activeStep - 1,
      },
      () => {
        this.rootRef.current?.scrollTo(0, 0);
      }
    );
  };

  handleReset = () => {
    this.setState(
      {
        activeStep: 0,
      },
      () => {
        this.rootRef.current?.scrollTo(0, 0);
      }
    );
  };
  updateStep = (step) => {
    // Summary and Payment show prices, so with hidden prices the stepper labels past
    // Reporting can only lead to the schedule step.
    const nextStep =
      this.isPriceHidden() && step >= this.getSummaryStep()
        ? this.getScheduleStep()
        : step;
    this.setState(
      {
        activeStep: nextStep,
      },
      () => {
        this.rootRef.current?.scrollTo(0, 0);
      }
    );
  };

  selectedCustomPackage = (pkg, index) => {
    this.setState({
      selectPackageIndex: index,
      selectPackage: pkg,
    });
  };
  setCurrentAboutUsStep = (currentAboutUsStep, callBackFunction) => {
    this.setState(
      {
        currentAboutUsStep: currentAboutUsStep,
      },
      () => {
        this.rootRef.current?.scrollTo(0, 0);
        if(callBackFunction){
          callBackFunction();
        }
        
      }
    );
  };
  setStep1Selection = (selection) => {
    this.setState({
      step1Selection: selection,
    });
  };
  setStep2Selection = (selection) => {
    this.setState({
      step2Selection: selection,
    });
  };
  setStep3Selection = (selection) => {
    const step3Selection = this.state.step3Selection.map((opt) => {
      return opt.id;
    });
    if (step3Selection.indexOf(selection.id) > -1) {
      this.setState({
        step3Selection: [...this.state.step3Selection].filter((opt) => {
          return opt.id != selection.id;
        }),
      });
    } else {
      this.setState({
        step3Selection: [...this.state.step3Selection, selection],
      });
    }
  };
  setSelectedPackage = (packageIndex) => {
    this.setState({
      selectedPackage: packageIndex,
    });
  };

  setAboutUsCashflowSelection = (selection) => {
    const aboutUsCashflowSelection = this.state.aboutUsCashflowSelection.map(
      (opt) => {
        return opt.id;
      }
    );
    if (aboutUsCashflowSelection.indexOf(selection.id) > -1) {
      this.setState({
        aboutUsCashflowSelection: [
          ...this.state.aboutUsCashflowSelection,
        ].filter((opt) => {
          return opt.id != selection.id;
        }),
      });
    } else {
      this.setState({
        aboutUsCashflowSelection: [
          ...this.state.aboutUsCashflowSelection,
          selection,
        ],
      });
    }
  };
  setCashflowSelection = (selection) => {
    const cashflowSelection = this.state.cashflowSelection.map((opt) => {
      return opt.id;
    });
    const cashflowDontNeedHelpId = this.state.cashflowSelection.find(
      (businessNeed) => {
        return (
          businessNeed.attributes.description ===
          cashflowDontNeedHelpDescription
        );
      }
    );

    if (selection.attributes.description === cashflowDontNeedHelpDescription) {
      if (cashflowSelection.indexOf(selection.id) > -1) {
        this.setState({
          cashflowSelection: [...this.state.cashflowSelection].filter((opt) => {
            return opt.id != selection.id;
          }),
        });
      } else {
        this.setState({
          cashflowSelection: [selection],
        });
      }
    } else {
      this.setCashflowSelectionNew(
        cashflowSelection,
        cashflowDontNeedHelpId,
        selection
      );
    }
  };
  setCashflowSelectionNew = (
    cashflowSelection,
    cashflowDontNeedHelpId,
    selection
  ) => {
    if (cashflowSelection.indexOf(cashflowDontNeedHelpId?.id) > -1) {
      this.setState(
        {
          cashflowSelection: [...this.state.cashflowSelection].filter((opt) => {
            return opt.id != cashflowDontNeedHelpId.id;
          }),
        },
        () => {
          if (cashflowSelection.indexOf(selection.id) > -1) {
            this.setState({
              cashflowSelection: [...this.state.cashflowSelection].filter(
                (opt) => {
                  return opt.id != selection.id;
                }
              ),
            });
          } else {
            this.setState({
              cashflowSelection: [...this.state.cashflowSelection, selection],
            });
          }
        }
      );
    } else {
      if (cashflowSelection.indexOf(selection.id) > -1) {
        this.setState({
          cashflowSelection: [...this.state.cashflowSelection].filter((opt) => {
            return opt.id != selection.id;
          }),
        });
      } else {
        this.setState({
          cashflowSelection: [...this.state.cashflowSelection, selection],
        });
      }
    }
  };

  setTaxSavingSelection = (selection) => {
    const taxSavingSelection = this.state.taxSavingSelection.map((opt) => {
      return opt.id;
    });
    const taxSavingMaximizingTaxId = this.state.taxSavingSelection.find(
      (businessNeed) => {
        return (
          businessNeed.attributes.description === taxSavingMaximizingDescription
        );
      }
    );

    if (selection.attributes.description === taxSavingMaximizingDescription) {
      if (taxSavingSelection.indexOf(selection.id) > -1) {
        this.setState({
          taxSavingSelection: [...this.state.taxSavingSelection].filter(
            (opt) => {
              return opt.id != selection.id;
            }
          ),
        });
      } else {
        this.setState({
          taxSavingSelection: [selection],
        });
      }
    } else {
      this.setTaxSavingSelectionNew(
        taxSavingSelection,
        taxSavingMaximizingTaxId,
        selection
      );
    }
  };
  setTaxSavingSelectionNew = (
    taxSavingSelection,
    taxSavingMaximizingTaxId,
    selection
  ) => {
    if (taxSavingSelection.indexOf(taxSavingMaximizingTaxId?.id) > -1) {
      this.setState(
        {
          taxSavingSelection: [...this.state.taxSavingSelection].filter(
            (opt) => {
              return opt.id != taxSavingMaximizingTaxId.id;
            }
          ),
        },
        () => {
          if (taxSavingSelection.indexOf(selection.id) > -1) {
            this.setState({
              taxSavingSelection: [...this.state.taxSavingSelection].filter(
                (opt) => {
                  return opt.id != selection.id;
                }
              ),
            });
          } else {
            this.setState({
              taxSavingSelection: [...this.state.taxSavingSelection, selection],
            });
          }
        }
      );
    } else if (taxSavingSelection.indexOf(selection.id) > -1) {
      this.setState({
        taxSavingSelection: [...this.state.taxSavingSelection].filter((opt) => {
          return opt.id != selection.id;
        }),
      });
    } else {
      this.setState({
        taxSavingSelection: [...this.state.taxSavingSelection, selection],
      });
    }
  };
  setBusinessNeedSelection = (selection) => {
    const businessNeedSelection = this.state.businessNeedSelection.map(
      (opt) => {
        return opt?.id;
      }
    );
    const businessNeedReireId = this.state.businessNeedSelection.find(
      (businessNeed) => {
        return (
          businessNeed?.attributes?.description ===
          careerNeedRetirmentDescription
        );
      }
    );

    if (selection.attributes.description === careerNeedRetirmentDescription) {
      if (businessNeedSelection.indexOf(selection.id) > -1) {
        this.setState({
          businessNeedSelection: [...this.state.businessNeedSelection].filter(
            (opt) => {
              return opt?.id != selection?.id;
            }
          ),
        });
      } else {
        this.setState({
          businessNeedSelection: [selection],
        });
      }
    } else {
      this.setBusinessNeedSelectionNew(
        businessNeedSelection,
        businessNeedReireId,
        selection
      );
    }
  };
  setBusinessNeedSelectionNew = (
    businessNeedSelection,
    businessNeedReireId,
    selection
  ) => {
    if (businessNeedSelection.indexOf(businessNeedReireId?.id) > -1) {
      this.setState(
        {
          businessNeedSelection: [...this.state.businessNeedSelection].filter(
            (opt) => {
              return opt?.id != businessNeedReireId?.id;
            }
          ),
        },
        () => {
          if (businessNeedSelection.indexOf(selection.id) > -1) {
            this.setState({
              businessNeedSelection: [
                ...this.state.businessNeedSelection,
              ].filter((opt) => {
                return opt?.id != selection.id;
              }),
            });
          } else {
            this.setState({
              businessNeedSelection: [
                ...this.state.businessNeedSelection,
                selection,
              ],
            });
          }
        }
      );
    } else if (businessNeedSelection.indexOf(selection.id) > -1) {
      this.setState({
        businessNeedSelection: [...this.state.businessNeedSelection].filter(
          (opt) => {
            return opt?.id != selection.id;
          }
        ),
      });
    } else {
      this.setState({
        businessNeedSelection: [...this.state.businessNeedSelection, selection],
      });
    }
  };
  setSavingSelection = (selection) => {
    const savingSelection = this.state.savingSelection.map((opt) => {
      return opt.id;
    });
    if (savingSelection.indexOf(selection.id) > -1) {
      this.setState({
        savingSelection: [...this.state.savingSelection].filter((opt) => {
          return opt.id != selection.id;
        }),
      });
    } else {
      this.setState({
        savingSelection: [...this.state.savingSelection, selection],
      });
    }
  };
  setReportingSelection = (selection) => {
    const reportSelection = this.state.reportSelection.map((opt) => {
      return opt?.id;
    });
    if (reportSelection.indexOf(selection.id) > -1) {
      this.setState({
        reportSelection: [...this.state.reportSelection].filter((opt) => {
          return opt?.id != selection.id;
        }),
      });
    } else {
      this.setState({
        reportSelection: [...this.state.reportSelection, selection],
      });
    }
  };
  setValueByDynamicName = (name, value) => {
    this.setState({
      [name]: value,
    });
  };
  handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      paymentType: (event.target as HTMLInputElement).value,
    });
  };
  goToSummaryPage = () => {
    if (this.state.taxPayerType == "business") {
      this.setState({
        activeStep: 6,
        openFaq: true,
      });
    } else {
      this.setState({
        activeStep: 5,
        openFaq: true,
      });
    }
  };
  childStepContent = (step) => {
    console.log(this.state.cpaData);
    if (step === 0) {
      return (
        <AboutUsSurveyStep
          firmQuestions={this.state.firmQuestions}
          firmAnswers={this.state.firmAnswers}
          setFirmAnswer={this.setFirmAnswer.bind(this)}
          getHeadingOfStep3={this.getHeadingOfStep3.bind(this)}
          getStepno3byStep1AndStep2={this.getStepno3byStep1AndStep2.bind(this)}
          isAboutusEnable={this.state.aboutUsEnable}
          setManagePayroll={this.setManagePayroll.bind(this)}
          updateStep={this.updateStep}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          taxPayerType={this.state.taxPayerType}
          stepContent={this.state.stepContent}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          currentAboutUsStep={this.state.currentAboutUsStep}
          setCurrentAboutUsStep={this.setCurrentAboutUsStep.bind(this)}
          step1Selection={this.state.step1Selection}
          step2Selection={this.state.step2Selection}
          step3Selection={this.state.step3Selection}
          setStep1Selection={this.setStep1Selection.bind(this)}
          setStep2Selection={this.setStep2Selection.bind(this)}
          setStep3Selection={this.setStep3Selection.bind(this)}
          totalAnnualIncome={this.state.totalAnnualIncome}
          taxFillingStatus={this.state.taxFillingStatus}
          isRealStateBusinessOutSideResidense={
            this.state.isRealStateBusinessOutSideResidense
          }
          isTradeOnMonthlyBasis={this.state.isTradeOnMonthlyBasis}
          isTradeCrypto={this.state.isTradeCrypto}
          isOwnerShipInAnotherBusiness={this.state.isOwnerShipInAnotherBusiness}
          isIncomeInAnotherStateOrCountary={
            this.state.isIncomeInAnotherStateOrCountary
          }
          isActiveIssueWithIRS={this.state.isActiveIssueWithIRS}
          isAllIncomeinOneState={this.state.isAllIncomeinOneState}
          noOfStateIncomeEarnIn={this.state.noOfStateIncomeEarnIn}
          no_of_countries_earn={this.state.no_of_countries_earn}
          firstName={this.state.firstName}
          lastName={this.state.lastName}
          email={this.state.email}
          phoneNumber={this.state.phoneNumber}
          country_code={this.state.country_code}
          currentAccountingSystem={this.state.currentAccountingSystem}
          currentEntityStructure={this.state.currentEntityStructure}
          currentPayRollSystem={this.state.currentPayRollSystem}
          industryType={this.state.industryType}
          annualRevenue={this.state.annualRevenue}
          otherBusinessPartner={this.state.otherBusinessPartner}
          noOfEmployee={this.state.noOfEmployee}
          isManagePayroll={this.state.isManagePayroll}
          isHelpNeededinAccounting={this.state.isHelpNeededinAccounting}
          noOFBankAccount={this.state.noOFBankAccount}
          isManageInvoice={this.state.isManageInvoice}
          noOFInvoice={this.state.noOFInvoice}
          isBalanceSheetAccurate={this.state.isBalanceSheetAccurate}
          noOfmonthForBalanceSheet={this.state.noOfmonthForBalanceSheet}
          setValueByDynamicName={this.setValueByDynamicName.bind(this)}
          aboutUsCashflowSelection={this.state.aboutUsCashflowSelection}
          setAboutUsCashflowSelection={this.setAboutUsCashflowSelection.bind(
            this
          )}
          cpaDetail={this.state.cpaData}
          iconColor={this.state.cpaData?.theme?.primary_color}
        />
      );
    } else if (step === 1) {
      return (
        <CashFlow
          firmQuestions={this.state.firmQuestions}
          firmAnswers={this.state.firmAnswers}
          setFirmAnswer={this.setFirmAnswer.bind(this)}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          stepContent={this.state.stepContent}
          taxPayerType={this.state.taxPayerType}
          cashflowSelection={this.state.cashflowSelection}
          setCashflowSelection={this.setCashflowSelection.bind(this)}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          iconColor={this.state.cpaData?.theme?.primary_color}
        />
      );
    } else if (step === 2) {
      return (
        <TaxSaving
          firmQuestions={this.state.firmQuestions}
          firmAnswers={this.state.firmAnswers}
          setFirmAnswer={this.setFirmAnswer.bind(this)}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          taxPayerType={this.state.taxPayerType}
          stepContent={this.state.stepContent}
          taxSavingSelection={this.state.taxSavingSelection}
          setTaxSavingSelection={this.setTaxSavingSelection.bind(this)}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          iconColor={this.state.cpaData?.theme?.primary_color}
        />
      );
    } else if (step === 3) {
      return (
        <BusinessNeed
          firmQuestions={this.state.firmQuestions}
          firmAnswers={this.state.firmAnswers}
          setFirmAnswer={this.setFirmAnswer.bind(this)}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          stepContent={this.state.stepContent}
          taxPayerType={this.state.taxPayerType}
          businessNeedSelection={this.state.businessNeedSelection}
          setBusinessNeedSelection={this.setBusinessNeedSelection.bind(this)}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          iconColor={this.state.cpaData?.theme?.primary_color}
        />
      );
    }
  };
  getStepContent = (step: number, classes = {}) => {
    if (step < 4) {
      return this.childStepContent(step);
    } else if (step === 4) {
      return this.state.taxPayerType === "business" ? (
        <Saving
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          stepContent={this.state.stepContent}
          taxPayerType={this.state.taxPayerType}
          setSavingSelection={this.setSavingSelection.bind(this)}
          savingSelection={this.state.savingSelection}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          saveSurvey={this.saveSurvey.bind(this)}
          iconColor={this.state.cpaData?.theme?.primary_color}
        />
      ) : (
        <Reporting
          firmQuestions={this.state.firmQuestions}
          firmAnswers={this.state.firmAnswers}
          setFirmAnswer={this.setFirmAnswer.bind(this)}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          stepContent={this.state.stepContent}
          taxPayerType={this.state.taxPayerType}
          setReportingSelection={this.setReportingSelection.bind(this)}
          reportSelection={this.state.reportSelection}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          isLoaderStep={this.state.isLoaderStep}
          saveSurvey={this.saveSurvey.bind(this)}
          iconColor={this.state.cpaData?.theme?.primary_color}
        />
      );
    } else if (step === 5) {
      return this.state.taxPayerType !== "business" ? (
        <Summary
          openFaq={this.state.openFaq}
          isPaymentEnable={this.state.isPaymentEnable}
          createChecklistforSelectedPackage={this.createChecklistforSelectedPackage.bind(
            this
          )}
          cpaDetail={this.state.cpaData}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          updateStep={this.updateStep.bind(this)}
          setTaxPerType={this.setTaxPerType}
          taxPayerType={this.state.taxPayerType}
          setCurrentSummaryStep={this.setCurrentSummaryStep.bind(this)}
          currentSummaryStep={this.state.currentSummaryStep}
          packageList={this.state.packageList}
          selectedPackage={this.state.selectedPackage}
          setSelectedPackage={this.setSelectedPackage.bind(this)}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          collectPayment={this.collectPayment}
          saveSurvey={this.saveSurvey.bind(this)}
          handleRadioChange={this.handleRadioChange}
          paymentType={this.state.paymentType}
          sendEmailTemplate={this.sendEmailTemplate.bind(this)}
          survey_id={this.state.survey_id}
          cpaSurveySetting={this.state.cpaSurveySetting}
          surveyDetail={this.state.surveyDetail}
          package_self_enrollment={this.state.package_self_enrollment}
          openPotentialSavings={this.openPotentialSavings}
          showThankYouScreen={this.showThankYouScreen}
          saveSurveyAddons={this.saveSurveyAddons}
        />
      ) : (
        <Reporting
          firmQuestions={this.state.firmQuestions}
          firmAnswers={this.state.firmAnswers}
          setFirmAnswer={this.setFirmAnswer.bind(this)}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          setTaxPerType={this.setTaxPerType}
          stepContent={this.state.stepContent}
          taxPayerType={this.state.taxPayerType}
          setReportingSelection={this.setReportingSelection.bind(this)}
          reportSelection={this.state.reportSelection}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          iconColor={this.state.cpaData?.theme?.primary_color}
          saveSurvey={this.saveSurvey.bind(this)}
          isLoaderStep={this.state.isLoaderStep}
        />
      );
    } else if (step === 6) {
      return this.state.taxPayerType !== "business" ? (
        this.getDynamicPaymentPage()
      ) : (
        <Summary
          openFaq={this.state.openFaq}
          createChecklistforSelectedPackage={this.createChecklistforSelectedPackage.bind(
            this
          )}
          surveyDetail={this.state.surveyDetail}
          survey_id={this.state.survey_id}
          isPaymentEnable={this.state.isPaymentEnable}
          cpaDetail={this.state.cpaData}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          updateStep={this.updateStep.bind(this)}
          currentSummaryStep={this.state.currentSummaryStep}
          setCurrentSummaryStep={this.setCurrentSummaryStep.bind(this)}
          selectedPackage={this.state.selectedPackage}
          setSelectedPackage={this.setSelectedPackage.bind(this)}
          setTaxPerType={this.setTaxPerType}
          taxPayerType={this.state.taxPayerType}
          packageList={this.state.packageList}
          getQuestionAndOptionsByStepNo={this.getQuestionAndOptionsByStepNo.bind(
            this
          )}
          collectPayment={this.collectPayment}
          handleRadioChange={this.handleRadioChange}
          paymentType={this.state.paymentType}
          sendEmailTemplate={this.sendEmailTemplate.bind(this)}
          cpaSurveySetting={this.state.cpaSurveySetting}
          package_self_enrollment={this.state.package_self_enrollment}
          openPotentialSavings={this.openPotentialSavings}
          showThankYouScreen={this.showThankYouScreen}
          saveSurveyAddons={this.saveSurveyAddons}
        />
      );
    } else if (step === 7) {
      return this.state.taxPayerType == "business" ? (
        this.getDynamicPaymentPage()
      ) : (
        <MeetingSchrdulePage
          cpaDetail={this.state.cpaData}
          goToSummaryPage={this.isPriceHidden() ? undefined : this.goToSummaryPage}
        />
      );
    } else if (step === 8) {
      return (
        <MeetingSchrdulePage
          cpaDetail={this.state.cpaData}
          goToSummaryPage={this.isPriceHidden() ? undefined : this.goToSummaryPage}
        />
      );
    }
  };
  getDynamicPaymentPage = () => {
    if (this.state.isPaymentEnable) {
      return (
        <PaymentPage
          cpaDetail={this.state.cpaData}
          isPaymentSuccess={this.state.isPaymentSuccess}
          selectedPackage={this.state.selectedPackage}
          collectPayment={this.collectPayment.bind(this)}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
          isEcheckPaymentAvailable={this.state.isEcheckPaymentAvailable}
          openPotentialSavings={this.openPotentialSavings}
          package_management_id={this.state.selectedPackage?.id}
          paymentCategory="cfsSurvey"
          showToast={this.props.showToast}
        />
      );
    } else {
      return (
        <MeetingSchrdulePage
          cpaDetail={this.state.cpaData}
          goToSummaryPage={this.isPriceHidden() ? undefined : this.goToSummaryPage}
        />
      );
    }
  };
  setTheme = (theme) => {
    this.setState({
      theme: {
        ...themeProps,
        palette: {
          ...themeProps?.palette,
          primary: {
            main: theme?.primary_color || MAGIC_LINK_PRIMARY,
          },
          secondary: {
            main:
              theme?.secondary_color || themeProps?.palette?.secondary?.main,
          },
        },
        overrides: {
          ...themeProps.overrides,
          MuiButton: {
            textPrimary: {
              ...themeProps.overrides.MuiButton.textPrimary,
              color: theme?.primary_color || MAGIC_LINK_PRIMARY,
              height: "3.8rem",
            },
          },
          MuiOutlinedInput: {
            ...themeProps.overrides.MuiOutlinedInput,
            root: {
              ...themeProps.overrides.MuiOutlinedInput.root,
              "&.Mui-focused": {
                border: `2px solid ${theme?.primary_color ||
                  MAGIC_LINK_PRIMARY}`,
                backgroundColor: "#fff",
              },
            },
          },
        },
      },
    });
  };
  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  };

  openPotentialSavings = () => {
    this.props.openDialogBox({
      title: "",
      width: "60%",
      renderedComponent: PotentialSavings,
      withCustomDialog: false,
    });
  };
  getHeadingOfStep3 = (step) => {
    let content = "";
    switch (step) {
      case 1.1:
      case 1.4:
        content =
          "Is there anything missing in your current relationship with your tax pro?";
        break;
      case 1.2:
      case 1.5:
        content =
          "What results would be valuable enough for you to start using a tax pro?";
        break;
      case 1.3:
      case 1.6:
        content =
          "Is there any specific direction you'd like us to be focusing our time more on?";
        break;
    }
    return content;
  };

  getCountedMainSteps = (steps) => {
    const summaryIndex = steps.indexOf("Summary");
    if (summaryIndex > -1) {
      return summaryIndex + 1;
    }
    return steps.indexOf("Reporting") + 1;
  };

  isExistingClient = () =>
    getOptionOrderNo(this.state.step1Selection) ===
    CURRENT_SITUATION.EXISTING_CLIENT;

  getStepDescription = (section) => {
    const aboutYouSteps = getAboutYouStepCount(
      this.state.taxPayerType,
      this.isExistingClient()
    );
    const isContactStep =
      this.state.activeStep === 0 &&
      this.state.currentAboutUsStep === aboutYouSteps - 1;
    // The contact card already shows this text; Will asked to keep only that one.
    return isContactStep ? undefined : section.description;
  };

  render() {
    const { classes } = this.props;
    let steps = [];
    if (this.state.taxPayerType === "business") {
      steps = [
        "About You",
        "Cash Flow",
        "Tax Savings",
        "Business Needs",
        "Savings",
        "Reporting",
        "Summary",
      ];
    } else {
      steps = [
        "About You",
        "Cash Flow",
        "Tax Savings",
        "Career Needs",
        "Reporting",
        "Summary",
      ];
    }

    const isPriceHidden = this.isPriceHidden();
    if (isPriceHidden) {
      steps = steps.filter((label) => label !== "Summary");
    }
    if (this.state.isPaymentEnable && !isPriceHidden) {
      steps.push("Payment");
    }
    const meetingLink = this.state?.cpaData?.survey_setting?.data?.attributes
      ?.meeting_link;
    if (meetingLink) {
      steps.push("Schedule");
    }
    const displayedStep =
      isPriceHidden && this.state.activeStep >= this.getSummaryStep()
        ? this.getSummaryStep()
        : this.state.activeStep;
    const isFlowFinished =
      this.state.isPaymentSuccess || this.state.isPriceHiddenThankYou;
    const progress = getStepProgress({
      activeStep: displayedStep,
      currentAboutUsStep: this.state.currentAboutUsStep,
      taxPayerType: this.state.taxPayerType,
      isExistingClient: this.isExistingClient(),
      countedMainSteps: this.getCountedMainSteps(steps),
    });
    const section = progress ? getStepSection(steps[displayedStep]) : null;
    const firmTheme = this.state.cpaData?.theme;
    const helpHref = getFirmContactHref(firmTheme);
    const showStepHeader =
      !!section && !isFlowFinished && !this.state.isLoaderStep;

    return (
      <ThemeProvider theme={createTheme(this.state.theme)}>
        <StepProgressContext.Provider value={isFlowFinished ? null : progress}>
          <div className={classes.page}>
            <Prompt
              when={
                !!this.state.step1Selection &&
                !!this.state.survey_id &&
                !this.state.selectedPackage &&
                !isPriceHidden
              }
              message="Changes that you made may not be saved"
            />
            <MagicLinkHeader
              logo={firmTheme?.logo}
              firmName={getFirmName(this.state.cpaData)}
              helpHref={helpHref}
              meetingLink={meetingLink}
            />
            <div ref={this.rootRef} className={classes.root}>
              <TernaryCheck
                condition={!isFlowFinished}
                trueComponent={
                  <div className={classes.container}>
                    {showStepHeader && (
                      <StepHeader
                        title={section.title}
                        description={this.getStepDescription(section)}
                      />
                    )}
                    <Grid container>
                      <Grid item xs={12}>
                        {this.state.cpaData &&
                          this.getStepContent(this.state.activeStep)}
                      </Grid>
                    </Grid>
                  </div>
                }
                falseComponent={
                  this.state.isPriceHiddenThankYou ? (
                    <PriceHiddenThankYou />
                  ) : (
                    <Thankyou selectedPackage={this.state.selectedPackage} />
                  )
                }
              />
            </div>
          </div>
        </StepProgressContext.Provider>
      </ThemeProvider>
    );
  }
}
const SurveySteperWithRouter = withRouter(SurveySteper);
const SurveySteperWithToast = withToast(SurveySteperWithRouter);
const SurveySteperWithLoader = withLoader(SurveySteperWithToast);
const SurveySteperWithAlertBox = withAlertBox(SurveySteperWithLoader);
const SurveySteperWithDialogBox = withDialogBox(SurveySteperWithAlertBox);

export default withStyles((theme) =>
  createStyles(
    {
      page: {
        minHeight: "100vh",
        backgroundColor: magicLinkColors.page,
      },
      root: {
        height: `calc(100vh - ${magicLinkLayout.headerHeight}px)`,
        overflow: "auto",
        boxSizing: "border-box",
        paddingBottom: magicLinkLayout.footerHeight + 24,
        "&::-webkit-scrollbar": {
          width: "8px",
          backgroundColor: magicLinkColors.page,
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#C7C7C8",
          borderRadius: "8px",
        },
      },
      container: {
        display: "flex",
        flexDirection: "column",
        gap: 24,
        maxWidth: magicLinkLayout.contentMaxWidth,
        margin: "0 auto",
        padding: "24px 24px 0",
        boxSizing: "content-box",
        [theme.breakpoints.down("xs")]: {
          padding: "16px 16px 0",
        },
      },
    },
    { withTheme: true }
  )
)(SurveySteperWithDialogBox);
